import React from "react";
import colors from "../../../../../styles/colorPalette";
import ButtonTextOnly from "../../../../commons/Buttons/ButtonTextOnly";
import { Wrapper } from "./styled";
import { useHistory } from "react-router-dom";
import { PATH_FORM } from "../../../../pages/App/constants";

const BackButton = () => {
  const history = useHistory();

  const goToView = () => {
    history.push(PATH_FORM);
  };

  return (
    <Wrapper>
      <ButtonTextOnly text={"Volver"} background={colors.button1} color={colors.blue1} onClick={goToView} />
    </Wrapper>
  );
};

export default BackButton;
